import React, { createContext, useContext, useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "./AuthContext";

const OrgContext = createContext();

export function useOrg() {
  return useContext(OrgContext);
}

export function OrgProvider({ children, forcedOrgId }) {
  const { userProfile } = useAuth();
  
  // forcedOrgId ha priorità (Platform Owner che entra in un'org)
  // altrimenti usa l'orgId del profilo utente
  const effectiveOrgId = forcedOrgId || userProfile?.organizationId || null;

  // Dati veri dell'organizzazione EFFETTIVAMENTE in uso — mai quella del profilo personale
  // di chi è loggato. Nato da un bug reale trovato più volte nel progetto: pagine diverse
  // leggevano "organization" da useAuth() (sempre l'org personale) invece di quella visitata
  // con "Entra", mostrando nome/piano sbagliati al Platform Owner, e in un caso (Features
  // Settings) rischiando di scrivere per errore sull'organizzazione propria invece di quella
  // che si intendeva modificare. Centralizzato qui una volta sola, invece di un fetch
  // duplicato in ogni pagina che ne ha bisogno.
  const [orgVisitata, setOrgVisitata] = useState(null);
  useEffect(() => {
    if (!effectiveOrgId) { setOrgVisitata(null); return; }
    return onSnapshot(doc(db, "organizations", effectiveOrgId), snap => {
      setOrgVisitata(snap.exists() ? { id: snap.id, ...snap.data() } : null);
    });
  }, [effectiveOrgId]);

  return (
    <OrgContext.Provider value={{ effectiveOrgId, forcedOrgId, orgVisitata }}>
      {children}
    </OrgContext.Provider>
  );
}
